// src/components/MobileHeader.tsx
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { HiMenu, HiX } from 'react-icons/hi';

interface Props {
  isMenuOpen: boolean;
  toggleMenu: () => void;
}

const MobileHeader: React.FC<Props> = ({ isMenuOpen, toggleMenu }) => {
  const location = useLocation();

  const getPageTitle = () => {
    if (location.pathname.startsWith('/settings')) return 'Settings';
    if (location.pathname.startsWith('/dashboard')) return 'Dashboard';
    if (location.pathname.startsWith('/admin')) return 'Admin';
    if (location.pathname.startsWith('/pricing')) return 'Pricing';
    if (location.pathname.startsWith('/contact')) return 'Contact';
    return 'Get Second Opinion';
  };

  return (
    <header className="bg-white shadow-sm sm:hidden h-16 flex items-center justify-between px-4 border-b border-gray-200">
      <Link to="/" className="flex-shrink-0">
        <img src="/assets/GetSecondOpinion_483sq.png" alt="Logo" className="h-9 w-9" />
      </Link>

      <div className="absolute left-0 right-0 text-center pointer-events-none">
        <h1 className="text-base font-medium text-gray-800">{getPageTitle()}</h1>
      </div>

      <button
        onClick={toggleMenu}
        className="p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
        aria-label="Toggle menu"
      >
        {isMenuOpen ? <HiX className="h-6 w-6" /> : <HiMenu className="h-6 w-6" />}
      </button>
    </header>
  );
};

export default MobileHeader;
